import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { COMPLAINTS_STATUS } from '../constants';
import { complaintsConfig } from '../data/data-selectors';

const DEFAULT_COMPLAINT_STATUS_DESCRIPTIONS = {
  [COMPLAINTS_STATUS.OPEN]: 'Open',
  [COMPLAINTS_STATUS.CLOSED]: 'Closed',
};

function useComplaintsStatus() {
  const data = useSelector(complaintsConfig);

  const allStatusDescriptions = useMemo(
    () => data?.allStatusDescriptions || DEFAULT_COMPLAINT_STATUS_DESCRIPTIONS,
    [data]
  );

  const complaintStatusLabelFactory = useCallback(
    (complaintStatus) =>
      allStatusDescriptions[complaintStatus] || complaintStatus,
    [allStatusDescriptions]
  );

  return {
    complaintStatusLabelFactory,
    allStatusDescriptions,
  };
}

export { useComplaintsStatus };
